module.exports = __webpack_public_path__ + "img/salesAuthorizationLetterUrl.920da1fa.png";